import { useContext } from 'react';
import { useWindowManager } from '@/contexts/WindowManager';

// Safe hook that won't throw errors if WindowManager context is not available
export const useSafeWindowManager = () => {
  try {
    return {
      windowManager: useWindowManager(),
      isAvailable: true
    };
  } catch (error) {
    return {
      windowManager: {
        openWindow: () => console.warn('WindowManager not available'),
        closeWindow: () => console.warn('WindowManager not available'),
        focusWindow: () => console.warn('WindowManager not available'),
        minimizeWindow: () => console.warn('WindowManager not available'),
        maximizeWindow: () => console.warn('WindowManager not available'),
        restoreWindow: () => console.warn('WindowManager not available'),
        moveWindow: () => console.warn('WindowManager not available'),
        resizeWindow: () => console.warn('WindowManager not available'),
        isWindowOpen: () => false,
        windows: [],
        highestZIndex: 100,
        activeWindowId: undefined,
        activeWindow: undefined,
        isMobile: false,
        isTablet: false,
        screenDimensions: { width: 0, height: 0 }
      },
      isAvailable: false
    };
  }
};